import { useCallback } from 'react';
import { addFiles } from '@/media/assetStore';
import { pickFiles } from '@/media/pick';
import { useStore } from '@/state/store';

/** Adds photos to the library and optionally drops the first one into a cell. */
export function useAddPhotos() {
  return useCallback(async (files?: File[], targetCell?: string) => {
    const s = useStore.getState();
    const list = files ?? (await pickFiles());
    if (!list.length) return [];

    s.setUi({ busy: `Importing ${list.length} photo${list.length > 1 ? 's' : ''}…` });
    const { metas, failed } = await addFiles(list);
    s.setUi({ busy: null });

    if (metas.length) {
      s.addAssets(metas);
      // What a freshly imported photo means is the tool's business.
      if (s.tool === 'collage') {
        if (targetCell) s.assign(targetCell, metas[0].id);
        else if (!Object.values(s.project.slots).some((slot) => slot.assetId)) {
          useStore.getState().autoFill();
        }
      } else if (s.tool === 'splitter' && !s.splitter.source.assetId) {
        // The splitter has exactly one picture, and an empty frame is the
        // whole reason someone just picked a file.
        s.setSource(metas[0].id);
      } else if (s.tool === 'carousel') {
        // A photo nobody can see is not much use — put it on the strip.
        for (const meta of metas) useStore.getState().addImageLayer(meta.id);
      }
    }
    if (failed.length) {
      s.toast(`${failed.length} file${failed.length > 1 ? 's' : ''} could not be read`, 'error');
    } else if (metas.length) {
      s.toast(`Added ${metas.length} photo${metas.length > 1 ? 's' : ''}`, 'success');
    }
    return metas;
  }, []);
}
